// Imports
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DoctorCard from "../components/DoctorCard";

// Cardiology
import Samba from "../images/DR.SAMBASIVA RAO.JPG";
import Manga from "../images/Dr. Manga.JPG";
import Maitri from "../images/Dr. Maitri.JPG";
import Sailaja from "../images/Dr. Sailaja.JPG";
import UshaNag from "../images/Dr. Usha Nag.JPG";
import ANUSHA from "../images/DR.ANUSHA.JPG";
import RITHVIC from "../images/DR. RITHVIC.JPG";
import Swapnil from "../images/Dr Swapnil Kolpakwar.png";
import Keziah from "../images/Dr. Keziah joseph.JPG";
import Harshitha from "../images/Dr.Harshitha.JPG";

// Orthopedics
import Dheeraj from "../images/Dr.Dheeraj.JPG";
import Sreenath from "../images/Dr. Sreenath.JPG";
import SujitKumar from "../images/Dr. Sujit Kumar, Prof, Ortho.JPG";
import Vijay from "../images/Dr. Vijay.JPG";
import Anirudh from "../images/Dr.Anirudh.JPG";
import Sreekalyani from "../images/Dr.Sree kalyani.JPG";
import Srikanth from "../images/Dr.Srikanth.JPG";
import Vikram from "../images/Dr.Vikram.JPG";

// General Surgery
import Bhargav from "../images/Dr. Bhargav.JPG";
import NagaMaithry from "../images/Dr. Naga Maithry.JPG";
import Rahman from "../images/Dr. Rahman.JPG";
import Ravinder from "../images/Dr. Ravinder.JPG";
import SubbaRao from "../images/Dr. Subba Rao.JPG";
import Anasari from "../images/Dr.Anasari.JPG";
import Avinash from "../images/Dr.Avinash.JPG";
import Praneeth from "../images/Dr.Praneeth.JPG";
import Raghuram from "../images/Dr.Raghu ram.JPG";
import Srinivasbehara from "../images/Dr.Srinivas behara.JPG";

// Dermatology
import Akshay from "../images/Dr.Akshay.JPG";
import Divya from "../images/Dr.Divya.JPG";
import Harsha from "../images/Dr.Harsha.JPG";

// ENT
import AbdulMajid from "../images/Dr. Abdul Majid.JPG";
import Sravani from "../images/Dr. Sravani M.JPG";
import Uma from "../images/Dr. Uma P.JPG";

// Nephrology
import BHAVYADASARA from "../images/DR.BHAVYA DASARA.JPG";

// Gastroenterology
import KAPILTEJASWY from "../images/DR.KAPIL TEJASWY.JPG";

// Endocrinology
import Gautham from "../images/Dr. Gautham.JPG";

// Pulmonology
import Alekya from "../images/Dr. Alekya.JPG";
import Rajiv from "../images/Dr. Rajiv.JPG";

// ✅ Proper Data Object — OUTSIDE of any function
const DoctorsBySpeciality = {
  Cardiology: [
    {
      slug: "dr-sambasiva-rao",
      name: "Dr. Sambasiva Rao",
      specialty: "Cardiology",
      profile:
        "Expert in interventional cardiology with over 15 years of experience in treating complex heart conditions.",
      imageUrl: Samba,
      qualifications: "MBBS, MD, DM (Cardiology)",
        experience: "15+ Years",
        specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
        languages: ["English", "Telugu", "Hindi"],
        education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
        detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
        availableDays: ["Monday", "Wednesday", "Friday"],
        availableTime: "10:00 AM - 4:00 PM",
    },
  ],
  ObstetricsGynaecology: [
    {
      slug: "dr-Manga",
      name: "Dr. Manga",
      specialty: "Obstetrics & Gynaecology",
      profile:
        "Specializes in high-risk pregnancies and minimally invasive gynecologic surgeries.",
      imageUrl: Manga,
      qualifications: "MBBS, MD, DM (Obstetrics & Gynaecology)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Maitri",
      specialty: "Obstetrics & Gynaecology",
      profile:
        "Specializes in high-risk pregnancies and minimally invasive gynecologic surgeries.",
      imageUrl: Maitri,
      qualifications: "MBBS, MD, DM (Obstetrics & Gynaecology)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Sailaja",
      specialty: "Obstetrics & Gynaecology",
      profile:
        "Specializes in high-risk pregnancies and minimally invasive gynecologic surgeries.",
      imageUrl: Sailaja,
      qualifications: "MBBS, MD, DM (Obstetrics & Gynaecology)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Usha Nag",
      specialty: "Obstetrics & Gynaecology",
      profile:
        "Specializes in high-risk pregnancies and minimally invasive gynecologic surgeries.",
      imageUrl: UshaNag,
      qualifications: "MBBS, MD, DM (Obstetrics & Gynaecology)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
  ],
  Neurosurgery: [
    {
      name: "Dr. ANUSHA",
      specialty: "Neurosurgery",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: ANUSHA,
      qualifications: "MBBS, MD, DM (Neurosurgery)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "DR. RITHVIC",
      specialty: "Neurosurgery",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: RITHVIC,
      qualifications: "MBBS, MD, DM (Neurosurgery)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Swapnil Kolpakwar",
      specialty: "Neurosurgery",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Swapnil,
      qualifications: "MBBS, MD, DM (Neurosurgery)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Keziah joseph",
      specialty: "Pediatrics",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Keziah,
      qualifications: "MBBS, MD, DM (Pediatrics)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Harshitha",
      specialty: "Pediatrics",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Harshitha,
      qualifications: "MBBS, MD, DM (Pediatrics)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Dheeraj",
      specialty: "Orthopedics",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Dheeraj,
      qualifications: "MBBS, MD, DM (Orthopedics)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Sreenath",
      specialty: "Orthopedics",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Sreenath,
      qualifications: "MBBS, MD, DM (Orthopedics)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. SujitKumar",
      specialty: "Orthopedics",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: SujitKumar,
      qualifications: "MBBS, MD, DM (Orthopedics)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Vijay",
      specialty: "Orthopedics",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Vijay,
      qualifications: "MBBS, MD, DM (Orthopedics)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Anirudh",
      specialty: "Orthopedics",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Anirudh,
      qualifications: "MBBS, MD, DM (Orthopedics)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Sree kalyani",
      specialty: "Orthopedics",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Sreekalyani,
      qualifications: "MBBS, MD, DM (Orthopedics)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Srikanth",
      specialty: "Orthopedics",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Srikanth,
      qualifications: "MBBS, MD, DM (Orthopedics)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Vikram",
      specialty: "Orthopedics",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Vikram,
      qualifications: "MBBS, MD, DM (Orthopedics)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Bhargav",
      specialty: "General Surgery",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Bhargav,
      qualifications: "MBBS, MD, DM (General Surgery)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Naga Maithry",
      specialty: "General Surgery",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: NagaMaithry,
      qualifications: "MBBS, MD, DM (General Surgery)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Rahman",
      specialty: "General Surgery",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Rahman,
      qualifications: "MBBS, MD, DM (General Surgery)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Ravinder",
      specialty: "General Surgery",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Ravinder,
      qualifications: "MBBS, MD, DM (General Surgery)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Subba Rao",
      specialty: "General Surgery",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: SubbaRao,
      qualifications: "MBBS, MD, DM (General Surgery)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Anasari",
      specialty: "General Surgery",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Anasari,
      qualifications: "MBBS, MD, DM (General Surgery)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Avinash",
      specialty: "General Surgery",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Avinash,
      qualifications: "MBBS, MD, DM (General Surgery)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Praneeth",
      specialty: "General Surgery",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Praneeth,
      qualifications: "MBBS, MD, DM (General Surgery)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Raghu ram",
      specialty: "General Surgery",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Raghuram,
      qualifications: "MBBS, MD, DM (General Surgery)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Srinivas behara",
      specialty: "General Surgery",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Srinivasbehara,
      qualifications: "MBBS, MD, DM (General Surgery)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Akshay",
      specialty: "Dermatology",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Akshay,
      qualifications: "MBBS, MD, DM (Dermatology)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Divya",
      specialty: "Dermatology",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Divya,
      qualifications: "MBBS, MD, DM (Dermatology)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Harsha",
      specialty: "Dermatology",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Harsha,
      qualifications: "MBBS, MD, DM (Dermatology)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Abdul Majid",
      specialty: "ENT",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: AbdulMajid,
      qualifications: "MBBS, MD, DM (ENT)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Sravani",
      specialty: "ENT",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Sravani,
      qualifications: "MBBS, MD, DM (ENT)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    
    {
      name: "Dr. Uma",
      specialty: "ENT",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Uma,
      qualifications: "MBBS, MD, DM (ENT)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. BHAVYA DASARA",
      specialty: "Nephrology",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: BHAVYADASARA,
      qualifications: "MBBS, MD, DM (Nephrology)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. KAPIL TEJASWY",
      specialty: "Gastroenterology",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: KAPILTEJASWY,
      qualifications: "MBBS, MD, DM (Gastroenterology)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Gautham",
      specialty: "Endocrinology",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Gautham,
      qualifications: "MBBS, MD, DM (Endocrinology)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Alekya",
      specialty: "Pulmonology",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Alekya,
      qualifications: "MBBS, MD, DM (Pulmonology)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
    {
      name: "Dr. Rajiv",
      specialty: "Pulmonology",
      profile:
        "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      imageUrl: Rajiv,
      qualifications: "MBBS, MD, DM (Pulmonology)",
    experience: "15+ Years",
    specializations: ["Interventional Cardiology", "Heart Failure", "Angioplasty"],
    languages: ["English", "Telugu", "Hindi"],
    education: ["MBBS - XYZ Medical College", "MD - ABC Institute", "DM - Cardiology - DEF University"],
    detailedProfile: "Dr. Sambasiva Rao is a leading cardiologist...\n\nHe has conducted over 500 successful surgeries.",
    availableDays: ["Monday", "Wednesday", "Friday"],
    availableTime: "10:00 AM - 4:00 PM",
    },
  ],
};

// ✅ Export it at the top level (not inside any function)
export default DoctorsBySpeciality;
